// removed by extract-text-webpack-plugin
module.exports = {"root":"PriceFilterPopup__root__sqqfv","label":"PriceFilterPopup__label__2iwUj","labelSelected":"PriceFilterPopup__labelSelected__1d2zM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PriceFilter/PriceFilterPopup.css
// module id = 2056
// module chunks = 0